import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-rensselaer-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-rensselaer-ny", statusCode: 301 });
  },
});
